/**
 * Holds the admin handoff token (read from the URL fragment) in module memory only.
 * Never persist or log it.
 */
let heldToken: string | null = null

export function adminHandoffBeforeEnter (to: any, from: any, next: any) {
    const hashToken = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('h')
    if (hashToken) {
        heldToken = hashToken
    }
    window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search)
    if (to.hash) {
        next({ path: to.path, query: to.query, hash: '', replace: true })
    } else {
        next()
    }
}

export function takeAdminHandoffToken (): string | null {
    const token = heldToken
    heldToken = null
    return token
}
